import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body, html, #root {        
    width: 100%;    
    padding: 0;
    margin: 0;
    height: auto;
    min-height: 100vh;
  }
  
  /* Скрыть iframe от react-refresh или расширений браузера */
  iframe[style*="z-index: 2147483647"] {
    pointer-events: none !important;
    display: none !important;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RootWrapper = styled.div<any>`
  //width: 100%;
  display: flex;
  flex-direction: column;
  flex: auto;
  min-height: 100vh;
  align-items: center;
  margin-bottom: 100px;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BodyWrapper = styled.div<any>`
  width: 100%;
  max-width: 1200px;
  display: block;
  position: relative;
  height: 100%;
  margin-right: auto;
  margin-left: auto;
  padding: 0 15px;
  box-sizing: border-box;
`;
